export const LITE_REGISTRATION_EVENT_PREFIX = 'lite';
export const LITE_REGISTRATION_BY_PHONE = 'phone';
export const DEFAULT_REGISTRATION_EVENT_PREFIX = 'default';
